import React, { useState } from 'react';
import { XMarkIcon, SpinnerIcon, LinkIcon, CheckIcon, ExclamationTriangleIcon } from './Icons';
import { CIEN_CUADRAS_BUTTON_BLUE } from '../firebase/firebaseConfig';
import { CopyFallbackModal } from './CopyFallbackModal';

interface ShareGroupModalProps {
    isLoading: boolean;
    sharedUrl: string | null;
    error: string | null;
    onClose: () => void;
    shareTarget?: 'cliente' | 'asesor';
}

export const ShareGroupModal: React.FC<ShareGroupModalProps> = ({ isLoading, sharedUrl, error, onClose, shareTarget = 'cliente' }) => {
    const [copyModalState, setCopyModalState] = useState<{ isOpen: boolean; text: string; title: string } | null>(null);

    const handleCopy = () => {
        if (sharedUrl) {
            setCopyModalState({ isOpen: true, text: sharedUrl, title: "Copiar Enlace de Grupo" });
        }
    };
    
    const renderContent = () => {
        if (isLoading) {
            return (
                <div className="text-center py-8">
                    <SpinnerIcon className="w-12 h-12 text-sky-600 mx-auto mb-4" />
                    <p className="font-semibold text-gray-700">Generando enlace para el grupo...</p>
                </div>
            );
        }
        if (error) {
            return (
                 <div className="text-center py-8">
                    <ExclamationTriangleIcon className="w-12 h-12 text-red-500 mx-auto mb-4" />
                    <h3 className="text-xl font-semibold text-gray-800">Error al Generar Enlace</h3>
                    <p className="text-gray-600 mt-2">{error}</p>
                 </div>
            );
        }
        if (sharedUrl) {
            const message = shareTarget === 'asesor'
                ? "Copia y comparte este enlace con tu asesor. Podrá ver todos los inmuebles seleccionados."
                : "Copia y comparte este enlace con tus clientes. Podrán ver todos los inmuebles seleccionados.";

            return (
                <>
                    <h3 id="share-group-modal-title" className="text-xl font-medium leading-6 text-gray-900 text-center">
                        Enlace del Grupo Creado
                    </h3>
                    <p className="mt-2 text-sm text-center text-gray-600">
                        {message}
                    </p>
                    <div className="mt-6 flex items-stretch">
                        <input
                            type="text"
                            value={sharedUrl}
                            readOnly
                            className="flex-grow bg-gray-100 border border-gray-300 rounded-l-md px-3 py-2 text-sm text-gray-700 focus:outline-none"
                        />
                        <button
                            onClick={handleCopy}
                            className="px-4 py-2 border border-transparent text-sm font-medium rounded-r-md shadow-sm text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500 flex items-center"
                            style={{ backgroundColor: CIEN_CUADRAS_BUTTON_BLUE }}
                        >
                            <LinkIcon className="w-5 h-5 mr-2" />
                            Copiar
                        </button>
                    </div>
                </>
            );
        }
        return null;
    };


    return (
        <>
            <div className="fixed inset-0 bg-gray-600 bg-opacity-75 overflow-y-auto h-full w-full z-50 flex items-center justify-center p-4 !mt-0 !m-0" role="dialog" aria-modal="true" aria-labelledby="share-group-modal-title">
                <div className="relative bg-white rounded-lg shadow-xl max-w-lg w-full">
                    <div className="p-6">
                        <button
                            type="button"
                            onClick={onClose}
                            className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
                            aria-label="Cerrar modal"
                        >
                            <XMarkIcon className="w-6 h-6" />
                        </button>
                        {renderContent()}
                    </div>
                     <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse rounded-b-lg">
                        <button
                            type="button"
                            className="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                            onClick={onClose}
                        >
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
            {copyModalState?.isOpen && (
                <CopyFallbackModal
                    isOpen={copyModalState.isOpen}
                    onClose={() => setCopyModalState(null)}
                    textToCopy={copyModalState.text}
                    title={copyModalState.title}
                />
            )}
        </>
    );
};